import activityLogServices from '../services/activityLogServices.js';
import MiscFunction from '../helpers/misc-functions';

export default class ActivityLogsDataModel {

  /*************************************************************
   *
   *  Initialization
   *
   *************************************************************/

  constructor(store, dataModel) {
    this.store = store;
    this.dataModel = dataModel;
  }

  get stateTree() {
    return this.store.getState();
  }

  search(searchString, order, ascending, activity, activitySubType, startDate, endDate, perPage, whichPage, callBack){
    let page = whichPage ? whichPage : 1;
    activityLogServices.getEventHistories(searchString, order, ascending, activity, activitySubType, startDate, endDate, page, perPage).then(data => {
      if(data.error){
        this.dataModel.displayHTTPError('Getting location projects', data.error, true);
        if(callBack){
          callBack();
        }
      }
      else{
        this.eventHistories = data;
        if(callBack){
          callBack(data.eventHistories);
        }
      }
    });
  }

  getActivitiesList(callBack){
    activityLogServices.getActivitiesList().then(data => {
      this.activitiesList = data.activities;
      if (callBack) {
        callBack(data.activities);
      }
    });
  }

  set activitiesList(activitiesList){
    this.store.dispatch({
      type: 'SET_ACTIVITIES_LIST',
      activitiesList: activitiesList,
    });
  }

  set eventHistories(eventHistories) {
    if (eventHistories && eventHistories.clear) {
      this.stateTree.activityLogs.eventHistories = null;
      this.stateTree.activityLogs.lastEventHistoriesPage = 0;
      this.stateTree.activityLogs.totalRecords = 0;
    }
    else if (eventHistories && eventHistories.create) {
      activityLogServices.createActivityLogEntry(eventHistories.create.activity, eventHistories.create.activity_sub_type, eventHistories.create.body);
    }
    else{
      let newEventHistories = [];
      if(eventHistories && eventHistories.eventHistories){
        if (this.stateTree.activityLogs && this.stateTree.activityLogs.eventHistories) {
          newEventHistories = MiscFunction.mergeArrays(this.stateTree.activityLogs.eventHistories, eventHistories.eventHistories);
        }
        else {
          newEventHistories = eventHistories.eventHistories;
        }
      }
      else{
        newEventHistories = eventHistories;
      }
      if(eventHistories  && newEventHistories){
        this.store.dispatch({
          type: 'SET_EVENT_HISTORIES',
          eventHistories: newEventHistories,
          lastEventHistoriesPage: eventHistories && eventHistories.lastEventHistoriesPage ? eventHistories.lastEventHistoriesPage : NaN,
          totalEventHistories: eventHistories && eventHistories.totalEventHistories ? eventHistories.totalEventHistories : NaN,
        });
      }
      else{
        this.store.dispatch({
          type: 'SET_EVENT_HISTORIES',
          eventHistories: null,
          lastEventHistoriesPage: 0,
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/ActivityLogsDataModel.js